import moment from 'moment'

function DateToJulian(date) {
   var year = date.getFullYear();
   var month = date.getMonth() + 1;
   var day = date.getDate();
   var a = Math.floor((14 - month) / 12);
   var y = Math.floor(year + 4800 - a);
   var m = month + 12 * a - 3;
   var julian = day + Math.floor((153 * m + 2) / 5) + (365 * y) + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) - 32045;
   return julian;
}

function JulianToDate(julian) {
   var y = 4716;
   var v = 3;
   var j = 1401;
   var u = 5;
   var m = 2;
   var s = 153;
   var n = 12;
   var w = 2;
   var r = 4;
   var B = 274277;
   var p = 1461;
   var C = -38;
   var f = julian + j + Math.floor((Math.floor((4 * julian + B) / 146097) * 3) / 4) + C;
   var e = r * f + v;
   var g = Math.floor((e % p) / r);
   var h = u * g + w;
   var D = Math.floor((h % s) / u) + 1;
   var M = ((Math.floor(h / s) + m) % n) + 1;
   var Y = Math.floor(e / p) - y + Math.floor((n + m - M) / n);
   return new Date(Y, M - 1, D);
}

function DateIsValid(date, format) {
   return moment(date, format, true).isValid()
}

function DateIsXMeasurementOld(date, format, measurement, invert = true) {
   //The supported measurements are 'years', 'months', 'weeks', 'days', 'hours', 'minutes', and 'seconds'
   let date_1
   if (format === "moment") { date_1 = date } else date_1 = moment(date, format)
   const date_2 = moment()
   if (invert && Math.sign(date_1.diff(date_2, measurement)) === -1) return date_1.diff(date_2, measurement) * -1
   return date_1.diff(date_2, measurement)
}




export { DateToJulian, JulianToDate, DateIsValid, DateIsXMeasurementOld, };